<template>
  <div class="text-center">
    <v-img
      width="500"
      class="mx-auto"
      contain
      src="~@/assets/images/mainpage.gif"
    />
    <h1 class="dastnevis red--text my-7">
      محتوای محدود
    </h1>
    <v-alert border="left" colored-border type="error" elevation="2">
      برای استفاده از خدمات این کتاب ابتدا باید این کتاب را خریداری نمایید
    </v-alert>
    <v-btn class="my-7" color="error" router to="/Books">
      بازگشت به لیست کتاب ها
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "buy-component",
  data() {
    return {};
  }
};
</script>
